import { HistoryWorkQuery } from '@Entities/search'
import { WorkSearch } from '@App/stores/search/models/work-search'

export class WorksReportRequestDTO {
    format: string
    artistName?: string
    mlcsongCodes?: string[]
    publisherIPI?: string
    publisherName?: string
    publisherPNumber?: string[]
    title?: string
    writerIPI?: string
    writerIPID?: string
    writerName?: string
    exactWorkTitle?: boolean
    exactWriterName?: boolean
    exactPublisherName?: boolean

    constructor(workSearch: WorkSearch) {
        this.format = ''
        this.artistName = workSearch.recordingArtists
        this.mlcsongCodes = workSearch.hfaSongCode ? [workSearch.hfaSongCode] : undefined
        this.publisherIPI = workSearch.originalPubIpiNameNumbers
        this.publisherName = workSearch.originalPubNamesExact || workSearch.originalPubNames
        this.publisherPNumber = workSearch.bothPublisherNumbers
        this.title =
            workSearch.combinedTitlesExact || workSearch.titleExact || workSearch.combinedTitles || workSearch.title
        this.writerIPI = workSearch.writerNameNumbers
        this.writerIPID = workSearch.writerIpIds
        this.writerName = workSearch.writerFullNamesExact || workSearch.writerFullNames
        this.exactWorkTitle = !!(workSearch.combinedTitlesExact || workSearch.titleExact)
        this.exactWriterName = !!workSearch.writerFullNamesExact
        this.exactPublisherName = !!workSearch.originalPubNamesExact
    }

    static fromWorkQuery(workQuery: HistoryWorkQuery): WorksReportRequestDTO {
        return new WorksReportRequestDTO({
            title: workQuery.title,
            writerFullNames: workQuery.writerName,
            writerNameNumbers: workQuery.writerIpi,
            writerIpIds: workQuery.writerIpId,
            originalPubNames: workQuery.publisherName,
            bothPublisherNumbers: workQuery.publisherNumber ? [workQuery.publisherNumber] : undefined,
            originalPubIpiNameNumbers: workQuery.publisherIpi,
            hfaSongCode: workQuery.songCode,
            recordingArtists: workQuery.artist,
        })
    }
}
